import React from "react";
import PropTypes from "prop-types";
import { useEffect } from "react";
import { useState } from "react";
import { Box, Typography, IconButton } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";


function CustomTablePagination(props) {
    const { count, page, rowsPerPage, onPageChange } = props;
    const totalPages = Math.ceil(count / rowsPerPage);
    const [current, setCurrent] = useState({ from: 0, to: 0 });

    useEffect(() => {
        if (!count) return;
        if (!page) {
            setCurrent({ from: 1, to: 5 });
        } else {
            setCurrent({ from: rowsPerPage * page + 1, to: rowsPerPage * (page + 1) });
        }
    }, [page, count]);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
            <Typography variant="body2" sx={{ marginRight: 2 }}>
                {current.from}-{current.to} of {count}
            </Typography>
            <IconButton
                disabled={page === 0}
                onClick={(event) => onPageChange(event, page - 1)}
                aria-label="previous page"
            >
                <ChevronLeft />
            </IconButton>
            <IconButton
                disabled={page === totalPages - 1}
                onClick={(event) => onPageChange(event, page + 1)}
                aria-label="next page"
            >
                <ChevronRight />
            </IconButton>
        </Box>
    );
}

CustomTablePagination.propTypes = {
    count: PropTypes.number.isRequired,
    page: PropTypes.number.isRequired,
    rowsPerPage: PropTypes.number.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onRowsPerPageChange: PropTypes.func.isRequired,
};

export default CustomTablePagination;
